<template>
  <form @submit.prevent="$emit('submit')">
    <string-form-field
      :label="$t('microCreditProduct.fields.name')"
      :value="value.name"
      :error="findError('name')"
      @input="propertyChange('name', $event)"
    />

    <!--
    Il pulsante nascosto permette di sottomettere il form alla pressione
    del tasto INVIO in uno dei campi contenuti; altrimenti l'invio del
    form non avviene.
    -->
    <b-button type="submit" class="d-none"></b-button>
  </form>
</template>
<script>
import EditorMixin from "vue-template/common/mixins/EditorMixin";

export default {
  mixins: [EditorMixin]
};
</script>
